export enum TimeTrackingStatus {
    Past,
    Current,
    Future
}
